import * as actionTypes from './actionTypes';
import axios from '../../axios/Backend';

export const fetchCallsSuccess = (data) =>{
    return {
        type:actionTypes.FETCH_CALLS_SUCCESS,
        calls:data
    };
};

export const clearNowCall = () =>{
    return {
        type:actionTypes.CLEAR_NOW_CALL,
    };
};

export const multiSelectUnselectCalls = (_id) => {
    return {
        type: actionTypes.MULTI_SELECT_UNSELECT_CALLS,
        _id:_id
    }
}

export const multiSelectUnselectAllCalls = (selectType) => {
    return {
        type: actionTypes.MULTI_SELECT_UNSELECT_ALL_CALLS,
        selectType:selectType
    }
}

export const multiSelectUnselectDialList = (_id) => {
    return {
        type: actionTypes.MULTI_SELECT_UNSELECT_DIALLIST,
        _id:_id
    }
}

export const multiSelectUnselectAllDialList = (selectType) => {
    return {
        type: actionTypes.MULTI_SELECT_UNSELECT_ALL_DIALLIST,
        selectType:selectType
    }
}

export const fetchCalls = (contain,numberOfCallsToFetch,startIndex) =>{
    return async dispatch => {
        try{
            let res=null
            if(!contain){
                res=await axios.get('/call/fetchcalls?numberOfCallsToFetch='+numberOfCallsToFetch+'&startIndex='+startIndex)
            }
            else{
                res=await axios.get('/call/fetchcalls/'+contain+'?numberOfCallsToFetch='+numberOfCallsToFetch+'&startIndex='+startIndex)
            }
            console.log('res')
            console.log(res)
            dispatch(fetchCallsSuccess(res.data))
        }catch(e){
            console.log('Dialer:fetchCalls:Error='+e)
        }
        
    }
};

export const CallReceivedEvent = (nowCall) => {

    return {
        type:actionTypes.CALL_RECEIVED_EVENT,
        nowCall:nowCall
    }

}

export const updateNowCall = (fields) => {
    return {
        type: actionTypes.UPDATE_NOW_CALL,
        fields
    }
}

export const CallAnsweredEvent = (nowCall) => {

    return {
        type:actionTypes.CALL_ANSWERED_EVENT,
        nowCall:nowCall
    }
    
}

export const CallReleasedEvent = (nowCall) => {

    return {
        type:actionTypes.CALL_RELEASED_EVENT,
        nowCall:nowCall
    }
    
}

export const makeCall = (callNum) => {

    return async dispatch => {
        try {
            const dataToSend={
                phone:callNum
            }
            await axios.post('/call/makecall',dataToSend)
        }catch(e){
            console.log('actions:Dialer:makeCall: file error='+ e)
        }
    }
}

export const disconnectCall = (callId) => {

    return async dispatch => {
        try {
            const dataToSend={
                callId:callId
            }
            await axios.post('/call/releasecall',dataToSend)
        }catch(e){
            console.log('actions:Dialer:disconnectCall: file error='+ e)
        }
    }
}

export const answerCall = (callId) => {

    return async dispatch => {
        try {
            const dataToSend={
                callId:callId
            }
            await axios.put('/call/answerCall',dataToSend)
        }catch(e){
            console.log('actions:Dialer:answerCall: file error='+ e)
        }
    }
}

export const fetchDialListSuccess = (data) =>{
    return {
        type:actionTypes.FETCH_DIAL_LIST_SUCCESS,
        dialList:data
    };
};

export const fetchDialList = (contain,numberOfDialListToFetch,startIndex) =>{
    return async dispatch => {
        try{
            let res=null
            if(!contain){
                res=await axios.get('/diallist?numberOfDialListToFetch='+numberOfDialListToFetch+'&startIndex='+startIndex)
            }
            else{
                res=await axios.get('/diallist/'+contain+'?numberOfDialListToFetch='+numberOfDialListToFetch+'&startIndex='+startIndex)
            }
            
            dispatch(fetchDialListSuccess(res.data))
        }catch(e){
            console.log('Dialer:fetchDialList:Error='+e)
        }
        
    }
};

export const dialListAdded = (data) =>{
    return {
        type:actionTypes.DIAL_LIST_ADDED,
        dialItem:data
    };
};

export const dialListUpdated = (data) =>{
    return {
        type:actionTypes.DIAL_LIST_UPDATED,
        dialList:data
    };
};

export const dialListDeleted = (data) =>{
    
    return {
        type:actionTypes.DIAL_LIST_DELETED,
        dialList:data
    };
};

export const dialListAutoDeleted = (data) =>{
    
    return {
        type:actionTypes.DIAL_LIST_AUTO_DELETED,
        dialList:data
    };
};

export const dialListPostponedToOtherAgent = (data) =>{
    return {
        type:actionTypes.DIAL_LIST_POSTPONED_TO_OTHER_AGENT,
        dialList:data
    };
};

export const dialListAdd = (data) =>{
    return async dispatch => {
        try{
            await axios.post('/diallist',data)
            
        }catch(e){
            console.log('Dialer:dialListAdd:Error='+e)
        }
        
    }
};

export const dialListUpdate = (data) =>{
    return async dispatch => {
        try{
            await axios.put('/diallist',data)
            
        }catch(e){
            console.log('Dialer:dialListUpdate:Error='+e)
        }
        
    }
};

export const dialListDelete = (data) =>{
    return async dispatch => {
        try{
            await axios.post('/diallist/delete',data)
            
        }catch(e){
            console.log('Dialer:dialListDelete:Error='+e)
        }
        
    }
};

export const callDelete = (id,isMany=false) =>{
    return async dispatch => {
        try{
            if(!id && !isMany){
                return console.log('Dialer:callDelete:must be id when isMany=false')
            }
            if(isMany){
                await axios.delete('/call/deleteall')
            }
            else{
                await axios.delete('/call/deleteone/'+id)
            }
        }catch(e){
            console.log('Dialer:callDelete:Error='+e)
        }
        
    }
};

export const callDeleted = (calls) =>{
    return {
        type:actionTypes.CALL_DELETED_EVENT,
        calls:calls
    };
};

export const callDetailsUpdate = (call) =>{
    return {
        type:actionTypes.CALL_DETAILS_UPDATE,
        call:call
    };
};

export const dialListDetailsUpdate = (dialList) =>{
    return {
        type:actionTypes.DIAL_LIST_DETAILS_UPDATE,
        dialList:dialList
    };
};

export const CallConfStart = (callId,phone) =>{
    
    return {
        type:actionTypes.CALL_CONF_START,
        callId:callId,
        phone:phone
    };
};

export const callHoldEvent = (data)=>{
    return {
        type:actionTypes.HOLD_STATUS_CHANGED,
        payload:data
    }
}

export const clearDialerState = ()=>{
    return {
        type:actionTypes.CLEAR_DIALER_STATE
    }
}

// CONTACTS

export const insertCallContact = (contact) => {
    return {
        type: actionTypes.INSERT_CALL_CONTACT,
        contact
    }
}

export const updateCallContact = (contact) => {
    return {
        type: actionTypes.UPDATE_CALL_CONTACT,
        contact
    }
}

export const deleteCallContact = (contact) => {
    return {
        type: actionTypes.DELETE_CALL_CONTACT,
        contact
    }
}

export const insertDialListContact = (contact) => {
    return {
        type: actionTypes.INSERT_DIALLIST_CONTACT,
        contact
    }
}

export const updateDialListContact = (contact) => {
    return {
        type: actionTypes.UPDATE_DIALLIST_CONTACT,
        contact
    }
}

export const deleteDialListContact = (contact) => {
    return {
        type: actionTypes.DELETE_DIALLIST_CONTACT,
        contact
    }
}